import { DynamicInputFormType, InputTypes } from "../../../../../Components";

export const CoverTestConfig: {
  type: string;
  title: string;
  fields: DynamicInputFormType[];
} = {
  type: "Cover Test",
  title: "Cover Test",
  fields: [
    {
      dataType: InputTypes.Date,
      accessor: "Date",
      Header: "Date",
    },
    {
      dataType: InputTypes.Select,
      Header: "Eye",
      accessor: "Eye",
      options: ["OD", "OS", "OU"],
    },
    {
      dataType: InputTypes.Number,
      Header: "Magnitude",
      accessor: "magnitude",
    },
    {
      dataType: InputTypes.Select,
      Header: "Distance",
      accessor: "Distance",
      options: ["Near", "Distance"],
    },
    {
      dataType: InputTypes.Select,
      Header: "Direction",
      accessor: "Direction",
      options: ["Eso", "Exo", "Hyper", "Hypo", "Cyclo"],
    },
    {
      dataType: InputTypes.Select,
      Header: "Tropia",
      accessor: "Tropia",
      options: ["Tropic", "Phoric"],
    },
    {
      dataType: InputTypes.Select,
      Header: "Type",
      accessor: "Type",
      options: ["Objective", "Subjective"],
    },
    {
      dataType: InputTypes.Select,
      Header: "Subtype",
      accessor: "Subtype",
      options: ["Intermittent", "Constant", "Alternating"],
    },
    {
      dataType: InputTypes.Select,
      Header: "Comitancy",
      accessor: "Comitancy",
      options: ["Comittant", "Incomitant"],
    },
  ],
};
